import {memo} from 'react';

import {Typography} from '@mui/material';
import {FlagImage, ParsedCountry} from 'react-international-phone';

import {
  VALUE_CONTAINER_STYLE,
  VALUE_DIAL_CODE_STYLE,
  VALUE_FLAG_STYLE,
} from './constants';

interface CountrySelectValueProps {
  country: ParsedCountry;
}

function CountrySelectValueComponent({country}: CountrySelectValueProps) {
  return (
    <div style={VALUE_CONTAINER_STYLE}>
      <FlagImage
        iso2={country.iso2}
        style={VALUE_FLAG_STYLE}
      />
      <Typography
        color="black"
        style={VALUE_DIAL_CODE_STYLE}>
        +{country.dialCode}
      </Typography>
    </div>
  );
}

export const CountrySelectValue = memo(CountrySelectValueComponent);
